/* eslint-disable */
// @ts-nocheck -- generated AJV standalone code; never edit directly.
// Regenerate: pnpm --filter @cogo/agentic-generator generate:composition-admission-validators
// Sources: @cogo/schema/v4/application-composition-plan.cogo.schema.json, @cogo/schema/v4/design-composition-release.cogo.schema.json
import ajvUcs2LengthModule from "ajv/dist/runtime/ucs2length.js";
import ajvEqualModule from "ajv/dist/runtime/equal.js";
const ajvUcs2Length = typeof ajvUcs2LengthModule === "function" ? ajvUcs2LengthModule : ajvUcs2LengthModule.default;
const ajvEqual = typeof ajvEqualModule === "function" ? ajvEqualModule : ajvEqualModule.default;
"use strict";
export const validatePlan = validate20;
const schema31 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"urn:cogo:v4:application-composition-plan","type":"object","additionalProperties":false,"required":["schemaVersion","planId","applicationCoreRef","target","locale","recipeRef","states","semanticNodes"],"properties":{"schemaVersion":{"const":"cogo.application-composition-plan.v1"},"planId":{"$ref":"#/$defs/nonEmptyString"},"applicationCoreRef":{"$ref":"#/$defs/nonEmptyString"},"target":{"const":"web"},"locale":{"$ref":"#/$defs/nonEmptyString"},"recipeRef":{"$ref":"#/$defs/nonEmptyString"},"states":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/nonEmptyString"}},"semanticNodes":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/semanticNode"}}},"$defs":{"nonEmptyString":{"type":"string","minLength":1},"content":{"type":"object","additionalProperties":false,"properties":{"title":{"$ref":"#/$defs/semanticContentValue"},"description":{"$ref":"#/$defs/semanticContentValue"},"label":{"$ref":"#/$defs/semanticContentValue"},"location":{"$ref":"#/$defs/semanticContentValue"},"pendingLabel":{"$ref":"#/$defs/semanticContentValue"},"successLabel":{"$ref":"#/$defs/semanticContentValue"},"errorLabel":{"$ref":"#/$defs/semanticContentValue"}}},"semanticContentValue":{"type":["string","number","boolean"]},"action":{"type":"object","additionalProperties":false,"required":["role","capabilityRef","slotRef"],"properties":{"role":{"enum":["primary","secondary","recovery","destructive"]},"capabilityRef":{"$ref":"#/$defs/nonEmptyString"},"slotRef":{"$ref":"#/$defs/nonEmptyString"}}},"semanticNode":{"type":"object","additionalProperties":false,"required":["nodeId","semanticRole","regionRef","content","visibleIn"],"properties":{"nodeId":{"$ref":"#/$defs/nonEmptyString"},"semanticRole":{"$ref":"#/$defs/nonEmptyString"},"regionRef":{"$ref":"#/$defs/nonEmptyString"},"content":{"$ref":"#/$defs/content"},"visibleIn":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/nonEmptyString"}},"action":{"$ref":"#/$defs/action"}}}}};
const schema32 = {"type":"string","minLength":1};
const func1 = ajvUcs2Length;
const func0 = ajvEqual;
const schema37 = {"type":"object","additionalProperties":false,"required":["nodeId","semanticRole","regionRef","content","visibleIn"],"properties":{"nodeId":{"$ref":"#/$defs/nonEmptyString"},"semanticRole":{"$ref":"#/$defs/nonEmptyString"},"regionRef":{"$ref":"#/$defs/nonEmptyString"},"content":{"$ref":"#/$defs/content"},"visibleIn":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/nonEmptyString"}},"action":{"$ref":"#/$defs/action"}}};
const schema41 = {"type":"object","additionalProperties":false,"properties":{"title":{"$ref":"#/$defs/semanticContentValue"},"description":{"$ref":"#/$defs/semanticContentValue"},"label":{"$ref":"#/$defs/semanticContentValue"},"location":{"$ref":"#/$defs/semanticContentValue"},"pendingLabel":{"$ref":"#/$defs/semanticContentValue"},"successLabel":{"$ref":"#/$defs/semanticContentValue"},"errorLabel":{"$ref":"#/$defs/semanticContentValue"}}};
const schema42 = {"type":["string","number","boolean"]};

function validate22(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate22.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if(!(((((((key0 === "title") || (key0 === "description")) || (key0 === "label")) || (key0 === "location")) || (key0 === "pendingLabel")) || (key0 === "successLabel")) || (key0 === "errorLabel"))){
const err0 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
if(data.title !== undefined){
let data0 = data.title;
if(((typeof data0 !== "string") && (!(typeof data0 == "number"))) && (typeof data0 !== "boolean")){
const err1 = {instancePath:instancePath+"/title",schemaPath:"#/$defs/semanticContentValue/type",keyword:"type",params:{type: schema42.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.description !== undefined){
let data1 = data.description;
if(((typeof data1 !== "string") && (!(typeof data1 == "number"))) && (typeof data1 !== "boolean")){
const err2 = {instancePath:instancePath+"/description",schemaPath:"#/$defs/semanticContentValue/type",keyword:"type",params:{type: schema42.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.label !== undefined){
let data2 = data.label;
if(((typeof data2 !== "string") && (!(typeof data2 == "number"))) && (typeof data2 !== "boolean")){
const err3 = {instancePath:instancePath+"/label",schemaPath:"#/$defs/semanticContentValue/type",keyword:"type",params:{type: schema42.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.location !== undefined){
let data3 = data.location;
if(((typeof data3 !== "string") && (!(typeof data3 == "number"))) && (typeof data3 !== "boolean")){
const err4 = {instancePath:instancePath+"/location",schemaPath:"#/$defs/semanticContentValue/type",keyword:"type",params:{type: schema42.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.pendingLabel !== undefined){
let data4 = data.pendingLabel;
if(((typeof data4 !== "string") && (!(typeof data4 == "number"))) && (typeof data4 !== "boolean")){
const err5 = {instancePath:instancePath+"/pendingLabel",schemaPath:"#/$defs/semanticContentValue/type",keyword:"type",params:{type: schema42.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.successLabel !== undefined){
let data5 = data.successLabel;
if(((typeof data5 !== "string") && (!(typeof data5 == "number"))) && (typeof data5 !== "boolean")){
const err6 = {instancePath:instancePath+"/successLabel",schemaPath:"#/$defs/semanticContentValue/type",keyword:"type",params:{type: schema42.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.errorLabel !== undefined){
let data6 = data.errorLabel;
if(((typeof data6 !== "string") && (!(typeof data6 == "number"))) && (typeof data6 !== "boolean")){
const err7 = {instancePath:instancePath+"/errorLabel",schemaPath:"#/$defs/semanticContentValue/type",keyword:"type",params:{type: schema42.type},message:"must be string,number,boolean"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate22.errors = vErrors;
return errors === 0;
}
validate22.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema50 = {"type":"object","additionalProperties":false,"required":["role","capabilityRef","slotRef"],"properties":{"role":{"enum":["primary","secondary","recovery","destructive"]},"capabilityRef":{"$ref":"#/$defs/nonEmptyString"},"slotRef":{"$ref":"#/$defs/nonEmptyString"}}};

function validate24(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate24.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.role === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "role"},message:"must have required property '"+"role"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.capabilityRef === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilityRef"},message:"must have required property '"+"capabilityRef"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.slotRef === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "slotRef"},message:"must have required property '"+"slotRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "role") || (key0 === "capabilityRef")) || (key0 === "slotRef"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.role !== undefined){
let data0 = data.role;
if(!((((data0 === "primary") || (data0 === "secondary")) || (data0 === "recovery")) || (data0 === "destructive"))){
const err4 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/enum",keyword:"enum",params:{allowedValues: schema50.properties.role.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.capabilityRef !== undefined){
let data1 = data.capabilityRef;
if(typeof data1 === "string"){
if(func1(data1) < 1){
const err5 = {instancePath:instancePath+"/capabilityRef",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/capabilityRef",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.slotRef !== undefined){
let data2 = data.slotRef;
if(typeof data2 === "string"){
if(func1(data2) < 1){
const err7 = {instancePath:instancePath+"/slotRef",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/slotRef",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate24.errors = vErrors;
return errors === 0;
}
validate24.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate21(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate21.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.nodeId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nodeId"},message:"must have required property '"+"nodeId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.semanticRole === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "semanticRole"},message:"must have required property '"+"semanticRole"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.regionRef === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "regionRef"},message:"must have required property '"+"regionRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.content === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "content"},message:"must have required property '"+"content"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.visibleIn === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "visibleIn"},message:"must have required property '"+"visibleIn"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "nodeId") || (key0 === "semanticRole")) || (key0 === "regionRef")) || (key0 === "content")) || (key0 === "visibleIn")) || (key0 === "action"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.nodeId !== undefined){
let data0 = data.nodeId;
if(typeof data0 === "string"){
if(func1(data0) < 1){
const err6 = {instancePath:instancePath+"/nodeId",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/nodeId",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.semanticRole !== undefined){
let data1 = data.semanticRole;
if(typeof data1 === "string"){
if(func1(data1) < 1){
const err8 = {instancePath:instancePath+"/semanticRole",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/semanticRole",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.regionRef !== undefined){
let data2 = data.regionRef;
if(typeof data2 === "string"){
if(func1(data2) < 1){
const err10 = {instancePath:instancePath+"/regionRef",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/regionRef",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.content !== undefined){
if(!(validate22(data.content, {instancePath:instancePath+"/content",parentData:data,parentDataProperty:"content",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate22.errors : vErrors.concat(validate22.errors);
errors = vErrors.length;
}
}
if(data.visibleIn !== undefined){
let data4 = data.visibleIn;
if(Array.isArray(data4)){
if(data4.length < 1){
const err12 = {instancePath:instancePath+"/visibleIn",schemaPath:"#/properties/visibleIn/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
const len0 = data4.length;
for(let i0=0; i0<len0; i0++){
let data5 = data4[i0];
if(typeof data5 === "string"){
if(func1(data5) < 1){
const err13 = {instancePath:instancePath+"/visibleIn/" + i0,schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/visibleIn/" + i0,schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
let i1 = data4.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data4[i1], data4[j0])){
const err15 = {instancePath:instancePath+"/visibleIn",schemaPath:"#/properties/visibleIn/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err16 = {instancePath:instancePath+"/visibleIn",schemaPath:"#/properties/visibleIn/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.action !== undefined){
if(!(validate24(data.action, {instancePath:instancePath+"/action",parentData:data,parentDataProperty:"action",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
errors = vErrors.length;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate21.errors = vErrors;
return errors === 0;
}
validate21.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate20(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="urn:cogo:v4:application-composition-plan" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate20.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.schemaVersion === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schemaVersion"},message:"must have required property '"+"schemaVersion"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.planId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "planId"},message:"must have required property '"+"planId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.applicationCoreRef === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "applicationCoreRef"},message:"must have required property '"+"applicationCoreRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.target === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.locale === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "locale"},message:"must have required property '"+"locale"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.recipeRef === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "recipeRef"},message:"must have required property '"+"recipeRef"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.states === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "states"},message:"must have required property '"+"states"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.semanticNodes === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "semanticNodes"},message:"must have required property '"+"semanticNodes"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "schemaVersion") || (key0 === "planId")) || (key0 === "applicationCoreRef")) || (key0 === "target")) || (key0 === "locale")) || (key0 === "recipeRef")) || (key0 === "states")) || (key0 === "semanticNodes"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.schemaVersion !== undefined){
if("cogo.application-composition-plan.v1" !== data.schemaVersion){
const err9 = {instancePath:instancePath+"/schemaVersion",schemaPath:"#/properties/schemaVersion/const",keyword:"const",params:{allowedValue: "cogo.application-composition-plan.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.planId !== undefined){
let data1 = data.planId;
if(typeof data1 === "string"){
if(func1(data1) < 1){
const err10 = {instancePath:instancePath+"/planId",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/planId",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.applicationCoreRef !== undefined){
let data2 = data.applicationCoreRef;
if(typeof data2 === "string"){
if(func1(data2) < 1){
const err12 = {instancePath:instancePath+"/applicationCoreRef",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/applicationCoreRef",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.target !== undefined){
if("web" !== data.target){
const err14 = {instancePath:instancePath+"/target",schemaPath:"#/properties/target/const",keyword:"const",params:{allowedValue: "web"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.locale !== undefined){
let data4 = data.locale;
if(typeof data4 === "string"){
if(func1(data4) < 1){
const err15 = {instancePath:instancePath+"/locale",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/locale",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.recipeRef !== undefined){
let data5 = data.recipeRef;
if(typeof data5 === "string"){
if(func1(data5) < 1){
const err17 = {instancePath:instancePath+"/recipeRef",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/recipeRef",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.states !== undefined){
let data6 = data.states;
if(Array.isArray(data6)){
if(data6.length < 1){
const err19 = {instancePath:instancePath+"/states",schemaPath:"#/properties/states/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
const len0 = data6.length;
for(let i0=0; i0<len0; i0++){
let data7 = data6[i0];
if(typeof data7 === "string"){
if(func1(data7) < 1){
const err20 = {instancePath:instancePath+"/states/" + i0,schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/states/" + i0,schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
let i1 = data6.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data6[i1], data6[j0])){
const err22 = {instancePath:instancePath+"/states",schemaPath:"#/properties/states/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err23 = {instancePath:instancePath+"/states",schemaPath:"#/properties/states/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.semanticNodes !== undefined){
let data8 = data.semanticNodes;
if(Array.isArray(data8)){
if(data8.length < 1){
const err24 = {instancePath:instancePath+"/semanticNodes",schemaPath:"#/properties/semanticNodes/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
const len1 = data8.length;
for(let i2=0; i2<len1; i2++){
if(!(validate21(data8[i2], {instancePath:instancePath+"/semanticNodes/" + i2,parentData:data8,parentDataProperty:i2,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
errors = vErrors.length;
}
}
}
else {
const err25 = {instancePath:instancePath+"/semanticNodes",schemaPath:"#/properties/semanticNodes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
else {
const err26 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
validate20.errors = vErrors;
return errors === 0;
}
validate20.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const validateRelease = validate27;
const schema53 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"urn:cogo:v4:design-composition-release","type":"object","additionalProperties":false,"required":["schemaVersion","releaseId","authorityStatus","target","sourceRefs","tokenRefs","components","recipes","actionTokenBindings"],"properties":{"schemaVersion":{"const":"cogo.design-composition-release.v1"},"releaseId":{"$ref":"#/$defs/nonEmptyString"},"authorityStatus":{"enum":["consumer-verified","project-validation"]},"target":{"const":"web"},"sourceRefs":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/sourceRef"}},"tokenRefs":{"type":"array","minItems":1,"uniqueItems":true,"items":{"$ref":"#/$defs/tokenRef"}},"components":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/component"}},"recipes":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/recipe"}},"actionTokenBindings":{"$ref":"#/$defs/actionTokenBindings"},"projectValidationBinding":{"$ref":"#/$defs/projectValidationBinding"}},"$defs":{"nonEmptyString":{"type":"string","minLength":1},"tokenRef":{"type":"string","pattern":"^(ctok:|uiox:token-|@ds:)"},"sourceRef":{"type":"string","pattern":"^[A-Za-z][A-Za-z0-9+.-]*:[^\\s]+$"},"actionRole":{"enum":["primary","secondary","recovery","destructive"]},"actionSlot":{"type":"object","additionalProperties":false,"required":["slotId","acceptsRoles","capabilityRefs","cardinality","exclusiveGroup"],"properties":{"slotId":{"$ref":"#/$defs/nonEmptyString"},"acceptsRoles":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/actionRole"}},"capabilityRefs":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/nonEmptyString"}},"cardinality":{"enum":["zero-or-one","exactly-one","many"]},"exclusiveGroup":{"$ref":"#/$defs/nonEmptyString"}}},"component":{"type":"object","additionalProperties":false,"required":["componentId","semanticRole","rendererRef","tokenRefs","actionSlots"],"properties":{"componentId":{"$ref":"#/$defs/nonEmptyString"},"semanticRole":{"$ref":"#/$defs/nonEmptyString"},"rendererRef":{"$ref":"#/$defs/nonEmptyString"},"tokenRefs":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/tokenRef"}},"actionSlots":{"type":"array","items":{"$ref":"#/$defs/actionSlot"}}}},"region":{"type":"object","additionalProperties":false,"required":["regionId","order","acceptsSemanticRoles","maxPrimaryActions"],"properties":{"regionId":{"$ref":"#/$defs/nonEmptyString"},"order":{"type":"integer","minimum":0},"acceptsSemanticRoles":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/nonEmptyString"}},"maxPrimaryActions":{"type":"integer","minimum":0}}},"recipe":{"type":"object","additionalProperties":false,"required":["recipeId","regions"],"properties":{"recipeId":{"$ref":"#/$defs/nonEmptyString"},"regions":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/region"}}}},"actionTokenBindings":{"type":"object","additionalProperties":false,"required":["primary","secondary","recovery","destructive"],"properties":{"primary":{"$ref":"#/$defs/tokenRef"},"secondary":{"$ref":"#/$defs/tokenRef"},"recovery":{"$ref":"#/$defs/tokenRef"},"destructive":{"$ref":"#/$defs/tokenRef"}}},"sha256":{"type":"string","pattern":"^sha256:[a-f0-9]{64}$"},"projectValidationBinding":{"type":"object","additionalProperties":false,"required":["aggregationScope","sliceId","sourceMaterializationReceiptRef","sourceMaterializationReceiptHash","observedRoleProjectionHash","contractRef","contractHash","processLocal","persistenceAllowed","promotionAllowed"],"properties":{"aggregationScope":{"const":"wonbanking-library-validation"},"sliceId":{"const":"account-selection-bottom-sheet"},"sourceMaterializationReceiptRef":{"type":"string","pattern":"^[A-Za-z][A-Za-z0-9+.-]*:[^\\s]+$"},"sourceMaterializationReceiptHash":{"$ref":"#/$defs/sha256"},"observedRoleProjectionHash":{"$ref":"#/$defs/sha256"},"contractRef":{"const":"cogo:project-validation-contract/wonbanking-account-selection-v1"},"contractHash":{"$ref":"#/$defs/sha256"},"processLocal":{"const":true},"persistenceAllowed":{"const":false},"promotionAllowed":{"const":false}}}},"oneOf":[{"properties":{"authorityStatus":{"const":"consumer-verified"}},"not":{"required":["projectValidationBinding"]}},{"required":["projectValidationBinding"],"properties":{"authorityStatus":{"const":"project-validation"}}}]};
const schema54 = {"type":"string","minLength":1};
const schema55 = {"type":"string","pattern":"^[A-Za-z][A-Za-z0-9+.-]*:[^\\s]+$"};
const schema56 = {"type":"string","pattern":"^(ctok:|uiox:token-|@ds:)"};
const func14 = Object.prototype.hasOwnProperty;
const pattern4 = new RegExp("^[A-Za-z][A-Za-z0-9+.-]*:[^\\s]+$", "u");
const pattern5 = new RegExp("^(ctok:|uiox:token-|@ds:)", "u");
const schema57 = {"type":"object","additionalProperties":false,"required":["componentId","semanticRole","rendererRef","tokenRefs","actionSlots"],"properties":{"componentId":{"$ref":"#/$defs/nonEmptyString"},"semanticRole":{"$ref":"#/$defs/nonEmptyString"},"rendererRef":{"$ref":"#/$defs/nonEmptyString"},"tokenRefs":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/tokenRef"}},"actionSlots":{"type":"array","items":{"$ref":"#/$defs/actionSlot"}}}};
const schema62 = {"type":"object","additionalProperties":false,"required":["slotId","acceptsRoles","capabilityRefs","cardinality","exclusiveGroup"],"properties":{"slotId":{"$ref":"#/$defs/nonEmptyString"},"acceptsRoles":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/actionRole"}},"capabilityRefs":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/nonEmptyString"}},"cardinality":{"enum":["zero-or-one","exactly-one","many"]},"exclusiveGroup":{"$ref":"#/$defs/nonEmptyString"}}};
const schema64 = {"enum":["primary","secondary","recovery","destructive"]};

function validate29(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate29.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.slotId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "slotId"},message:"must have required property '"+"slotId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.acceptsRoles === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "acceptsRoles"},message:"must have required property '"+"acceptsRoles"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.capabilityRefs === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilityRefs"},message:"must have required property '"+"capabilityRefs"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.cardinality === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "cardinality"},message:"must have required property '"+"cardinality"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.exclusiveGroup === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "exclusiveGroup"},message:"must have required property '"+"exclusiveGroup"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "slotId") || (key0 === "acceptsRoles")) || (key0 === "capabilityRefs")) || (key0 === "cardinality")) || (key0 === "exclusiveGroup"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.slotId !== undefined){
let data0 = data.slotId;
if(typeof data0 === "string"){
if(func1(data0) < 1){
const err6 = {instancePath:instancePath+"/slotId",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/slotId",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.acceptsRoles !== undefined){
let data1 = data.acceptsRoles;
if(Array.isArray(data1)){
if(data1.length < 1){
const err8 = {instancePath:instancePath+"/acceptsRoles",schemaPath:"#/properties/acceptsRoles/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if(!((((data2 === "primary") || (data2 === "secondary")) || (data2 === "recovery")) || (data2 === "destructive"))){
const err9 = {instancePath:instancePath+"/acceptsRoles/" + i0,schemaPath:"#/$defs/actionRole/enum",keyword:"enum",params:{allowedValues: schema64.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath:instancePath+"/acceptsRoles",schemaPath:"#/properties/acceptsRoles/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.capabilityRefs !== undefined){
let data3 = data.capabilityRefs;
if(Array.isArray(data3)){
if(data3.length < 1){
const err11 = {instancePath:instancePath+"/capabilityRefs",schemaPath:"#/properties/capabilityRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
const len1 = data3.length;
for(let i1=0; i1<len1; i1++){
let data4 = data3[i1];
if(typeof data4 === "string"){
if(func1(data4) < 1){
const err12 = {instancePath:instancePath+"/capabilityRefs/" + i1,schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/capabilityRefs/" + i1,schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath:instancePath+"/capabilityRefs",schemaPath:"#/properties/capabilityRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.cardinality !== undefined){
let data5 = data.cardinality;
if(!(((data5 === "zero-or-one") || (data5 === "exactly-one")) || (data5 === "many"))){
const err15 = {instancePath:instancePath+"/cardinality",schemaPath:"#/properties/cardinality/enum",keyword:"enum",params:{allowedValues: schema62.properties.cardinality.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.exclusiveGroup !== undefined){
let data6 = data.exclusiveGroup;
if(typeof data6 === "string"){
if(func1(data6) < 1){
const err16 = {instancePath:instancePath+"/exclusiveGroup",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/exclusiveGroup",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
else {
const err18 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
validate29.errors = vErrors;
return errors === 0;
}
validate29.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate28(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate28.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.componentId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "componentId"},message:"must have required property '"+"componentId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.semanticRole === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "semanticRole"},message:"must have required property '"+"semanticRole"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.rendererRef === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "rendererRef"},message:"must have required property '"+"rendererRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.tokenRefs === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "tokenRefs"},message:"must have required property '"+"tokenRefs"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.actionSlots === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "actionSlots"},message:"must have required property '"+"actionSlots"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "componentId") || (key0 === "semanticRole")) || (key0 === "rendererRef")) || (key0 === "tokenRefs")) || (key0 === "actionSlots"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.componentId !== undefined){
let data0 = data.componentId;
if(typeof data0 === "string"){
if(func1(data0) < 1){
const err6 = {instancePath:instancePath+"/componentId",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/componentId",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.semanticRole !== undefined){
let data1 = data.semanticRole;
if(typeof data1 === "string"){
if(func1(data1) < 1){
const err8 = {instancePath:instancePath+"/semanticRole",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/semanticRole",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.rendererRef !== undefined){
let data2 = data.rendererRef;
if(typeof data2 === "string"){
if(func1(data2) < 1){
const err10 = {instancePath:instancePath+"/rendererRef",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/rendererRef",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.tokenRefs !== undefined){
let data3 = data.tokenRefs;
if(Array.isArray(data3)){
if(data3.length < 1){
const err12 = {instancePath:instancePath+"/tokenRefs",schemaPath:"#/properties/tokenRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
const len0 = data3.length;
for(let i0=0; i0<len0; i0++){
let data4 = data3[i0];
if(typeof data4 === "string"){
if(!pattern5.test(data4)){
const err13 = {instancePath:instancePath+"/tokenRefs/" + i0,schemaPath:"#/$defs/tokenRef/pattern",keyword:"pattern",params:{pattern: "^(ctok:|uiox:token-|@ds:)"},message:"must match pattern \""+"^(ctok:|uiox:token-|@ds:)"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/tokenRefs/" + i0,schemaPath:"#/$defs/tokenRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath:instancePath+"/tokenRefs",schemaPath:"#/properties/tokenRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.actionSlots !== undefined){
let data5 = data.actionSlots;
if(Array.isArray(data5)){
const len1 = data5.length;
for(let i1=0; i1<len1; i1++){
if(!(validate29(data5[i1], {instancePath:instancePath+"/actionSlots/" + i1,parentData:data5,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate29.errors : vErrors.concat(validate29.errors);
errors = vErrors.length;
}
}
}
else {
const err16 = {instancePath:instancePath+"/actionSlots",schemaPath:"#/properties/actionSlots/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate28.errors = vErrors;
return errors === 0;
}
validate28.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema67 = {"type":"object","additionalProperties":false,"required":["recipeId","regions"],"properties":{"recipeId":{"$ref":"#/$defs/nonEmptyString"},"regions":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/region"}}}};
const schema69 = {"type":"object","additionalProperties":false,"required":["regionId","order","acceptsSemanticRoles","maxPrimaryActions"],"properties":{"regionId":{"$ref":"#/$defs/nonEmptyString"},"order":{"type":"integer","minimum":0},"acceptsSemanticRoles":{"type":"array","minItems":1,"items":{"$ref":"#/$defs/nonEmptyString"}},"maxPrimaryActions":{"type":"integer","minimum":0}}};

function validate33(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate33.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.regionId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "regionId"},message:"must have required property '"+"regionId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.order === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "order"},message:"must have required property '"+"order"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.acceptsSemanticRoles === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "acceptsSemanticRoles"},message:"must have required property '"+"acceptsSemanticRoles"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.maxPrimaryActions === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "maxPrimaryActions"},message:"must have required property '"+"maxPrimaryActions"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "regionId") || (key0 === "order")) || (key0 === "acceptsSemanticRoles")) || (key0 === "maxPrimaryActions"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.regionId !== undefined){
let data0 = data.regionId;
if(typeof data0 === "string"){
if(func1(data0) < 1){
const err5 = {instancePath:instancePath+"/regionId",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/regionId",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.order !== undefined){
let data1 = data.order;
if(!((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1)))){
const err7 = {instancePath:instancePath+"/order",schemaPath:"#/properties/order/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(typeof data1 == "number"){
if(data1 < 0 || isNaN(data1)){
const err8 = {instancePath:instancePath+"/order",schemaPath:"#/properties/order/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
if(data.acceptsSemanticRoles !== undefined){
let data2 = data.acceptsSemanticRoles;
if(Array.isArray(data2)){
if(data2.length < 1){
const err9 = {instancePath:instancePath+"/acceptsSemanticRoles",schemaPath:"#/properties/acceptsSemanticRoles/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
const len0 = data2.length;
for(let i0=0; i0<len0; i0++){
let data3 = data2[i0];
if(typeof data3 === "string"){
if(func1(data3) < 1){
const err10 = {instancePath:instancePath+"/acceptsSemanticRoles/" + i0,schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/acceptsSemanticRoles/" + i0,schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath:instancePath+"/acceptsSemanticRoles",schemaPath:"#/properties/acceptsSemanticRoles/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.maxPrimaryActions !== undefined){
let data4 = data.maxPrimaryActions;
if(!((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4)))){
const err13 = {instancePath:instancePath+"/maxPrimaryActions",schemaPath:"#/properties/maxPrimaryActions/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(typeof data4 == "number"){
if(data4 < 0 || isNaN(data4)){
const err14 = {instancePath:instancePath+"/maxPrimaryActions",schemaPath:"#/properties/maxPrimaryActions/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate33.errors = vErrors;
return errors === 0;
}
validate33.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate32(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate32.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.recipeId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "recipeId"},message:"must have required property '"+"recipeId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.regions === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "regions"},message:"must have required property '"+"regions"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "recipeId") || (key0 === "regions"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.recipeId !== undefined){
let data0 = data.recipeId;
if(typeof data0 === "string"){
if(func1(data0) < 1){
const err3 = {instancePath:instancePath+"/recipeId",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/recipeId",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.regions !== undefined){
let data1 = data.regions;
if(Array.isArray(data1)){
if(data1.length < 1){
const err5 = {instancePath:instancePath+"/regions",schemaPath:"#/properties/regions/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
if(!(validate33(data1[i0], {instancePath:instancePath+"/regions/" + i0,parentData:data1,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate33.errors : vErrors.concat(validate33.errors);
errors = vErrors.length;
}
}
}
else {
const err6 = {instancePath:instancePath+"/regions",schemaPath:"#/properties/regions/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
else {
const err7 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
validate32.errors = vErrors;
return errors === 0;
}
validate32.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema72 = {"type":"object","additionalProperties":false,"required":["primary","secondary","recovery","destructive"],"properties":{"primary":{"$ref":"#/$defs/tokenRef"},"secondary":{"$ref":"#/$defs/tokenRef"},"recovery":{"$ref":"#/$defs/tokenRef"},"destructive":{"$ref":"#/$defs/tokenRef"}}};

function validate36(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate36.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.primary === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "primary"},message:"must have required property '"+"primary"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.secondary === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "secondary"},message:"must have required property '"+"secondary"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.recovery === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "recovery"},message:"must have required property '"+"recovery"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.destructive === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "destructive"},message:"must have required property '"+"destructive"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "primary") || (key0 === "secondary")) || (key0 === "recovery")) || (key0 === "destructive"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.primary !== undefined){
let data0 = data.primary;
if(typeof data0 === "string"){
if(!pattern5.test(data0)){
const err5 = {instancePath:instancePath+"/primary",schemaPath:"#/$defs/tokenRef/pattern",keyword:"pattern",params:{pattern: "^(ctok:|uiox:token-|@ds:)"},message:"must match pattern \""+"^(ctok:|uiox:token-|@ds:)"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/primary",schemaPath:"#/$defs/tokenRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.secondary !== undefined){
let data1 = data.secondary;
if(typeof data1 === "string"){
if(!pattern5.test(data1)){
const err7 = {instancePath:instancePath+"/secondary",schemaPath:"#/$defs/tokenRef/pattern",keyword:"pattern",params:{pattern: "^(ctok:|uiox:token-|@ds:)"},message:"must match pattern \""+"^(ctok:|uiox:token-|@ds:)"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/secondary",schemaPath:"#/$defs/tokenRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.recovery !== undefined){
let data2 = data.recovery;
if(typeof data2 === "string"){
if(!pattern5.test(data2)){
const err9 = {instancePath:instancePath+"/recovery",schemaPath:"#/$defs/tokenRef/pattern",keyword:"pattern",params:{pattern: "^(ctok:|uiox:token-|@ds:)"},message:"must match pattern \""+"^(ctok:|uiox:token-|@ds:)"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/recovery",schemaPath:"#/$defs/tokenRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.destructive !== undefined){
let data3 = data.destructive;
if(typeof data3 === "string"){
if(!pattern5.test(data3)){
const err11 = {instancePath:instancePath+"/destructive",schemaPath:"#/$defs/tokenRef/pattern",keyword:"pattern",params:{pattern: "^(ctok:|uiox:token-|@ds:)"},message:"must match pattern \""+"^(ctok:|uiox:token-|@ds:)"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/destructive",schemaPath:"#/$defs/tokenRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
else {
const err13 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
validate36.errors = vErrors;
return errors === 0;
}
validate36.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

const schema77 = {"type":"object","additionalProperties":false,"required":["aggregationScope","sliceId","sourceMaterializationReceiptRef","sourceMaterializationReceiptHash","observedRoleProjectionHash","contractRef","contractHash","processLocal","persistenceAllowed","promotionAllowed"],"properties":{"aggregationScope":{"const":"wonbanking-library-validation"},"sliceId":{"const":"account-selection-bottom-sheet"},"sourceMaterializationReceiptRef":{"type":"string","pattern":"^[A-Za-z][A-Za-z0-9+.-]*:[^\\s]+$"},"sourceMaterializationReceiptHash":{"$ref":"#/$defs/sha256"},"observedRoleProjectionHash":{"$ref":"#/$defs/sha256"},"contractRef":{"const":"cogo:project-validation-contract/wonbanking-account-selection-v1"},"contractHash":{"$ref":"#/$defs/sha256"},"processLocal":{"const":true},"persistenceAllowed":{"const":false},"promotionAllowed":{"const":false}}};
const schema78 = {"type":"string","pattern":"^sha256:[a-f0-9]{64}$"};
const pattern12 = new RegExp("^sha256:[a-f0-9]{64}$", "u");

function validate38(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate38.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.aggregationScope === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "aggregationScope"},message:"must have required property '"+"aggregationScope"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.sliceId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sliceId"},message:"must have required property '"+"sliceId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.sourceMaterializationReceiptRef === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceMaterializationReceiptRef"},message:"must have required property '"+"sourceMaterializationReceiptRef"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.sourceMaterializationReceiptHash === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceMaterializationReceiptHash"},message:"must have required property '"+"sourceMaterializationReceiptHash"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.observedRoleProjectionHash === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "observedRoleProjectionHash"},message:"must have required property '"+"observedRoleProjectionHash"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.contractRef === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "contractRef"},message:"must have required property '"+"contractRef"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.contractHash === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "contractHash"},message:"must have required property '"+"contractHash"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.processLocal === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "processLocal"},message:"must have required property '"+"processLocal"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.persistenceAllowed === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "persistenceAllowed"},message:"must have required property '"+"persistenceAllowed"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.promotionAllowed === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "promotionAllowed"},message:"must have required property '"+"promotionAllowed"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key0 in data){
if(!(func14.call(schema77.properties, key0))){
const err10 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.aggregationScope !== undefined){
if("wonbanking-library-validation" !== data.aggregationScope){
const err11 = {instancePath:instancePath+"/aggregationScope",schemaPath:"#/properties/aggregationScope/const",keyword:"const",params:{allowedValue: "wonbanking-library-validation"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.sliceId !== undefined){
if("account-selection-bottom-sheet" !== data.sliceId){
const err12 = {instancePath:instancePath+"/sliceId",schemaPath:"#/properties/sliceId/const",keyword:"const",params:{allowedValue: "account-selection-bottom-sheet"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.sourceMaterializationReceiptRef !== undefined){
let data2 = data.sourceMaterializationReceiptRef;
if(typeof data2 === "string"){
if(!pattern4.test(data2)){
const err13 = {instancePath:instancePath+"/sourceMaterializationReceiptRef",schemaPath:"#/properties/sourceMaterializationReceiptRef/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z][A-Za-z0-9+.-]*:[^\\s]+$"},message:"must match pattern \""+"^[A-Za-z][A-Za-z0-9+.-]*:[^\\s]+$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/sourceMaterializationReceiptRef",schemaPath:"#/properties/sourceMaterializationReceiptRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.sourceMaterializationReceiptHash !== undefined){
let data3 = data.sourceMaterializationReceiptHash;
if(typeof data3 === "string"){
if(!pattern12.test(data3)){
const err15 = {instancePath:instancePath+"/sourceMaterializationReceiptHash",schemaPath:"#/$defs/sha256/pattern",keyword:"pattern",params:{pattern: "^sha256:[a-f0-9]{64}$"},message:"must match pattern \""+"^sha256:[a-f0-9]{64}$"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/sourceMaterializationReceiptHash",schemaPath:"#/$defs/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.observedRoleProjectionHash !== undefined){
let data4 = data.observedRoleProjectionHash;
if(typeof data4 === "string"){
if(!pattern12.test(data4)){
const err17 = {instancePath:instancePath+"/observedRoleProjectionHash",schemaPath:"#/$defs/sha256/pattern",keyword:"pattern",params:{pattern: "^sha256:[a-f0-9]{64}$"},message:"must match pattern \""+"^sha256:[a-f0-9]{64}$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/observedRoleProjectionHash",schemaPath:"#/$defs/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.contractRef !== undefined){
if("cogo:project-validation-contract/wonbanking-account-selection-v1" !== data.contractRef){
const err19 = {instancePath:instancePath+"/contractRef",schemaPath:"#/properties/contractRef/const",keyword:"const",params:{allowedValue: "cogo:project-validation-contract/wonbanking-account-selection-v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.contractHash !== undefined){
let data6 = data.contractHash;
if(typeof data6 === "string"){
if(!pattern12.test(data6)){
const err20 = {instancePath:instancePath+"/contractHash",schemaPath:"#/$defs/sha256/pattern",keyword:"pattern",params:{pattern: "^sha256:[a-f0-9]{64}$"},message:"must match pattern \""+"^sha256:[a-f0-9]{64}$"+"\""};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/contractHash",schemaPath:"#/$defs/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.processLocal !== undefined){
if(true !== data.processLocal){
const err22 = {instancePath:instancePath+"/processLocal",schemaPath:"#/properties/processLocal/const",keyword:"const",params:{allowedValue: true},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.persistenceAllowed !== undefined){
if(false !== data.persistenceAllowed){
const err23 = {instancePath:instancePath+"/persistenceAllowed",schemaPath:"#/properties/persistenceAllowed/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.promotionAllowed !== undefined){
if(false !== data.promotionAllowed){
const err24 = {instancePath:instancePath+"/promotionAllowed",schemaPath:"#/properties/promotionAllowed/const",keyword:"const",params:{allowedValue: false},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
else {
const err25 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
validate38.errors = vErrors;
return errors === 0;
}
validate38.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate27(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="urn:cogo:v4:design-composition-release" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate27.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs1 = errors;
let valid0 = false;
let passing0 = null;
const _errs2 = errors;
const _errs3 = errors;
const _errs4 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
let missing0;
if((data.projectValidationBinding === undefined) && (missing0 = "projectValidationBinding")){
const err0 = {};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
var valid1 = _errs4 === errors;
if(valid1){
const err1 = {instancePath,schemaPath:"#/oneOf/0/not",keyword:"not",params:{},message:"must NOT be valid"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
else {
errors = _errs3;
if(vErrors !== null){
if(_errs3){
vErrors.length = _errs3;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.authorityStatus !== undefined){
if("consumer-verified" !== data.authorityStatus){
const err2 = {instancePath:instancePath+"/authorityStatus",schemaPath:"#/oneOf/0/properties/authorityStatus/const",keyword:"const",params:{allowedValue: "consumer-verified"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
}
var _valid0 = _errs2 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = {};
props0.authorityStatus = true;
}
const _errs6 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.projectValidationBinding === undefined){
const err3 = {instancePath,schemaPath:"#/oneOf/1/required",keyword:"required",params:{missingProperty: "projectValidationBinding"},message:"must have required property '"+"projectValidationBinding"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.authorityStatus !== undefined){
if("project-validation" !== data.authorityStatus){
const err4 = {instancePath:instancePath+"/authorityStatus",schemaPath:"#/oneOf/1/properties/authorityStatus/const",keyword:"const",params:{allowedValue: "project-validation"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
var _valid0 = _errs6 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = props0 || {};
props0.authorityStatus = true;
}
}
}
if(!valid0){
const err5 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
else {
errors = _errs1;
if(vErrors !== null){
if(_errs1){
vErrors.length = _errs1;
}
else {
vErrors = null;
}
}
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.schemaVersion === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schemaVersion"},message:"must have required property '"+"schemaVersion"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.releaseId === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "releaseId"},message:"must have required property '"+"releaseId"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.authorityStatus === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "authorityStatus"},message:"must have required property '"+"authorityStatus"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.target === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "target"},message:"must have required property '"+"target"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.sourceRefs === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceRefs"},message:"must have required property '"+"sourceRefs"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.tokenRefs === undefined){
const err11 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "tokenRefs"},message:"must have required property '"+"tokenRefs"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data.components === undefined){
const err12 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "components"},message:"must have required property '"+"components"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.recipes === undefined){
const err13 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "recipes"},message:"must have required property '"+"recipes"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data.actionTokenBindings === undefined){
const err14 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "actionTokenBindings"},message:"must have required property '"+"actionTokenBindings"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
for(const key0 in data){
if(!(func14.call(schema53.properties, key0))){
const err15 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.schemaVersion !== undefined){
if("cogo.design-composition-release.v1" !== data.schemaVersion){
const err16 = {instancePath:instancePath+"/schemaVersion",schemaPath:"#/properties/schemaVersion/const",keyword:"const",params:{allowedValue: "cogo.design-composition-release.v1"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.releaseId !== undefined){
let data3 = data.releaseId;
if(typeof data3 === "string"){
if(func1(data3) < 1){
const err17 = {instancePath:instancePath+"/releaseId",schemaPath:"#/$defs/nonEmptyString/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/releaseId",schemaPath:"#/$defs/nonEmptyString/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.authorityStatus !== undefined){
let data4 = data.authorityStatus;
if(!((data4 === "consumer-verified") || (data4 === "project-validation"))){
const err19 = {instancePath:instancePath+"/authorityStatus",schemaPath:"#/properties/authorityStatus/enum",keyword:"enum",params:{allowedValues: schema53.properties.authorityStatus.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.target !== undefined){
if("web" !== data.target){
const err20 = {instancePath:instancePath+"/target",schemaPath:"#/properties/target/const",keyword:"const",params:{allowedValue: "web"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.sourceRefs !== undefined){
let data6 = data.sourceRefs;
if(Array.isArray(data6)){
if(data6.length < 1){
const err21 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/properties/sourceRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
const len0 = data6.length;
for(let i0=0; i0<len0; i0++){
let data7 = data6[i0];
if(typeof data7 === "string"){
if(!pattern4.test(data7)){
const err22 = {instancePath:instancePath+"/sourceRefs/" + i0,schemaPath:"#/$defs/sourceRef/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z][A-Za-z0-9+.-]*:[^\\s]+$"},message:"must match pattern \""+"^[A-Za-z][A-Za-z0-9+.-]*:[^\\s]+$"+"\""};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
else {
const err23 = {instancePath:instancePath+"/sourceRefs/" + i0,schemaPath:"#/$defs/sourceRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
let i1 = data6.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data6[i1], data6[j0])){
const err24 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/properties/sourceRefs/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err25 = {instancePath:instancePath+"/sourceRefs",schemaPath:"#/properties/sourceRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.tokenRefs !== undefined){
let data8 = data.tokenRefs;
if(Array.isArray(data8)){
if(data8.length < 1){
const err26 = {instancePath:instancePath+"/tokenRefs",schemaPath:"#/properties/tokenRefs/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
const len1 = data8.length;
for(let i2=0; i2<len1; i2++){
let data9 = data8[i2];
if(typeof data9 === "string"){
if(!pattern5.test(data9)){
const err27 = {instancePath:instancePath+"/tokenRefs/" + i2,schemaPath:"#/$defs/tokenRef/pattern",keyword:"pattern",params:{pattern: "^(ctok:|uiox:token-|@ds:)"},message:"must match pattern \""+"^(ctok:|uiox:token-|@ds:)"+"\""};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
else {
const err28 = {instancePath:instancePath+"/tokenRefs/" + i2,schemaPath:"#/$defs/tokenRef/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
let i3 = data8.length;
let j1;
if(i3 > 1){
outer1:
for(;i3--;){
for(j1 = i3; j1--;){
if(func0(data8[i3], data8[j1])){
const err29 = {instancePath:instancePath+"/tokenRefs",schemaPath:"#/properties/tokenRefs/uniqueItems",keyword:"uniqueItems",params:{i: i3, j: j1},message:"must NOT have duplicate items (items ## "+j1+" and "+i3+" are identical)"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
break outer1;
}
}
}
}
}
else {
const err30 = {instancePath:instancePath+"/tokenRefs",schemaPath:"#/properties/tokenRefs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data.components !== undefined){
let data10 = data.components;
if(Array.isArray(data10)){
if(data10.length < 1){
const err31 = {instancePath:instancePath+"/components",schemaPath:"#/properties/components/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
const len2 = data10.length;
for(let i4=0; i4<len2; i4++){
if(!(validate28(data10[i4], {instancePath:instancePath+"/components/" + i4,parentData:data10,parentDataProperty:i4,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate28.errors : vErrors.concat(validate28.errors);
errors = vErrors.length;
}
}
}
else {
const err32 = {instancePath:instancePath+"/components",schemaPath:"#/properties/components/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.recipes !== undefined){
let data12 = data.recipes;
if(Array.isArray(data12)){
if(data12.length < 1){
const err33 = {instancePath:instancePath+"/recipes",schemaPath:"#/properties/recipes/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
const len3 = data12.length;
for(let i5=0; i5<len3; i5++){
if(!(validate32(data12[i5], {instancePath:instancePath+"/recipes/" + i5,parentData:data12,parentDataProperty:i5,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate32.errors : vErrors.concat(validate32.errors);
errors = vErrors.length;
}
}
}
else {
const err34 = {instancePath:instancePath+"/recipes",schemaPath:"#/properties/recipes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data.actionTokenBindings !== undefined){
if(!(validate36(data.actionTokenBindings, {instancePath:instancePath+"/actionTokenBindings",parentData:data,parentDataProperty:"actionTokenBindings",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate36.errors : vErrors.concat(validate36.errors);
errors = vErrors.length;
}
}
if(data.projectValidationBinding !== undefined){
if(!(validate38(data.projectValidationBinding, {instancePath:instancePath+"/projectValidationBinding",parentData:data,parentDataProperty:"projectValidationBinding",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate38.errors : vErrors.concat(validate38.errors);
errors = vErrors.length;
}
}
}
else {
const err35 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
validate27.errors = vErrors;
return errors === 0;
}
validate27.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};
